import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* Copied from the ConsumerSite Pattern Library temporarily.
 *
 */

import React from "react";
import classnames from "classnames";
import styles from "./theme-provider.module.scss";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var ThemeProvider = function ThemeProvider(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? "default" : _ref$theme,
    children = _ref.children;
  return ___EmotionJSX("div", {
    "data-bpl": true,
    className: classnames(styles.themeProvider, _defineProperty({}, styles["theme-".concat(theme)], theme)),
    "data-constellation-theme": theme
  }, children);
};
export default ThemeProvider;